// extracted by mini-css-extract-plugin
export default {"title":"EmailConfirm_title_TCY3e","content":"EmailConfirm_content_SP9x6"};